module.exports = __webpack_public_path__ + "img/people_img_3_2.90591dcb.png";